import { Injectable } from '@angular/core';
import { RpaHttpService } from '../http/rpa-http.service';
import { Observable, Observer, fromEvent, map, merge, of } from 'rxjs';
import { ErpPrice } from 'src/app/models/goods/product';
import { Good } from 'src/app/models/sync.model';
import { ClientLimitQuery, Generic1CResponse } from 'src/app/models/limits.model';

@Injectable({
  providedIn: 'root'
})
export class ErpService {



  private online = false

  constructor(private rpa: RpaHttpService,) {

    this.checkNet().subscribe(o => {
      this.online = o;
    })

  }


  getPrice(buypointId: string): Observable<ErpPrice | undefined> {

    if (!this.online) { return of(undefined) }

    return this.rpa.post<ErpPrice>('/v2/api/erp/getprice_v2', { buypointId })

  }

  getOffer(buypointId: string): Observable<Good[] | undefined> {
    if (!this.online) { return of(undefined) }
    return this.rpa.post<Good[]>('/v2/api/erp/GetOffer', { buypointId })
  }


  getLimitQueries(buypointCode: string | undefined = undefined): Observable<Generic1CResponse<ClientLimitQuery>> {

    const filter = {
      Method: "GetLimitQueries",
    } as LimitQueriesFilter;

    if (buypointCode) {
      filter.BuypointCode = buypointCode;
    }

    return this.rpa.post<Generic1CResponse<ClientLimitQuery>>('/v2/api/erp/direct', filter)

  }


  createLimitQueriy(query: any) {
    query.Method = "LimitQuery";
    return this.rpa.post('/v2/api/erp/direct', query)
  }

  checkNet() {
    return merge(
      fromEvent(window, 'offline').pipe(map(() => false)),
      fromEvent(window, 'online').pipe(map(() => true)),
      new Observable((sub: Observer<boolean>) => {
        sub.next(navigator.onLine);
        sub.complete();
      }));
  }



  public uploadFile(file: File, bucket: string, path: string) {
    const formData = new FormData()



    formData.append('bucket', bucket)
    formData.append('path', path)
    formData.append('File', file)



    const uri = `/v2/api/erp/UploadFile`
    return this.rpa
      .postForm(uri, formData)

  }


}

interface LimitQueriesFilter {
  Method: string
  BuypointCode: string | undefined
}

export interface FileS3 {
  URL: string
}